module.exports = __webpack_public_path__ + "img/33_56.5f217a1c.png";